import script from "./RadiogroupRadio_blocks.vue?vue&type=script&lang=js"
export * from "./RadiogroupRadio_blocks.vue?vue&type=script&lang=js"

import "./RadiogroupRadio_blocks.vue?vue&type=style&index=0&id=2f846e95&lang=scss"

const __exports__ = script;

export default __exports__